import 'core-js/stable';
import 'regenerator-runtime/runtime';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {Power4, Strong} from "gsap";
import slick from "slick-carousel/slick/slick";
import Inputmask from "../.../../../node_modules/inputmask/dist/jquery.inputmask.min";








$(".inputmask").inputmask({"mask": "+7 (999) 999-9999"});

gsap.registerPlugin(ScrollTrigger);

gsap.to(".line__item", {
	duration: 23,
	ease: "none",
	x: "-=1903", //move each box 500px to right
	modifiers: {
	  x: gsap.utils.unitize(x => parseFloat(x) % 1903) //force x value to be between 0 and 500 using modulus
	},
	repeat: -1
});


ScrollTrigger.matchMedia({
	// "(min-width: 1024px)" : function() {
		// const panels = gsap.utils.toArray('.block_el');
		// const overlap = 0.7;

		// panels.forEach((panel, i) => {
		// const parent = document.createElement('div');
		// parent.classList.add("panel-wrapper");
		// parent.style.position = 'relative';
		// parent.style.height = `${panel.offsetHeight - 80}px`;

		// panel.parentNode.insertBefore(parent, panel);
		// parent.appendChild(panel);

		// gsap.set(panel, { y: i * panel.offsetHeight * (1 - overlap) });

		// let endTrigger;

		// if (i === 0) {
		// 	endTrigger = panels[2];
		// } else if (i === 1) {
		// 	endTrigger = panels[2];
		// }  else {
		// 	endTrigger = parent;
		// }

		// if (i === 0) {
		// 	endTrigger = panels[3];
		// } else if (i === 1) {
		// 	endTrigger = panels[3];
		// } else if (i === 2) {
		// 	endTrigger = panels[3];
		// } else {
		// 	endTrigger = parent;
		// }
		
	// 	ScrollTrigger.create({
	// 		trigger: parent,
	// 		start: 'top top',
	// 		endTrigger: endTrigger,
	// 		end: 'bottom 80%',
	// 		pin: panel,
	// 		pinSpacing: false,
	// 		// markers: true,
	// 	});
	// 	});
	// },
	"(min-width: 768px)" : function() {

	      const marquee = gsap.timeline({
			scrollTrigger: {
				trigger: ".landing",
				toggleActions: "play none none none",
				start: '30% 30%',
				onEnter: function(){ 
					if(document.querySelector(".landing")) {
						document.querySelector(".landing").classList.add("is-active");
					}
				},
				// markers: true
			},
			repeat: 0,
			repeatDelay: 1
		});


		const tween = gsap.timeline({
			scrollTrigger: {
				trigger: ".hero",
				toggleActions: "play reverse restart reset",
			},
			repeat: 0,
			repeatDelay: 1
		});

		tween.to(".mainslides__item", {
			duration: 0.5,
			opacity: 1,
			delay: .5,
			stagger: 0.6,
			//ease: "bounce"
		})

		tween.to(".hi", {
			duration: 0.5,
			opacity: 1,
			//ease: "bounce"
		})


		const tween2 = gsap.timeline({
			scrollTrigger: {
				trigger: ".grayform",
				toggleActions: "play none none none",
				start: 'top 30%',
				// markers: true,
			},
			repeat: 0,
			repeatDelay: 1
		});

		tween2.to(".grayform__image", {
			duration: 0.5,
			opacity: 1,
			stagger: 0.2,
			//ease: "bounce"
		})


		const tween3 = gsap.timeline({
			scrollTrigger: {
				trigger: ".teamblock",
				toggleActions: "play none none none",
				start: 'top 30%',
				// markers: true,
			},
			repeat: 0,
			repeatDelay: 1
		});
		tween3.fromTo(".teamblock__spec--margin", {
			duration: 0.5,
			marginLeft: "-15%", 
			// stagger: 0.2,
			//ease: "bounce"
		}, {
			duration: 0.5,
			marginLeft: "-3%", 
		})



			
	
// 		let wheel1 = verticalLoop(".landing__line .landing__line-item", {
// 			repeat: -1,
// 			center: true,
// 			speed: 0.5,
// 			draggable: false, // I'm just being fancy
// 			inertia: true // even fancier
// 		});
	

      
//       function verticalLoop(items, config) {
// 	items = gsap.utils.toArray(items);
// 	config = config || {};
// 	let onChange = config.onChange,
// 	  lastIndex = 0,
// 	  tl = gsap.timeline({
// 	    repeat: config.repeat,
// 	    onUpdate:
// 	      onChange &&
// 	      function () {
// 		let i = tl.closestIndex();
// 		if (lastIndex !== i) {
// 		  lastIndex = i;
// 		  onChange(items[i], i);
// 		}
// 	      },
// 	    paused: config.paused,
// 	    defaults: { ease: "none" },
// 	    onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)
// 	  }),
// 	  length = items.length,
// 	  startY = items[0].offsetTop,
// 	  times = [],
// 	  heights = [],
// 	  spaceBefore = [],
// 	  yPercents = [],
// 	  curIndex = 0,
// 	  center = config.center,
// 	  clone = (obj) => {
// 	    let result = {},
// 	      p;
// 	    for (p in obj) {
// 	      result[p] = obj[p];
// 	    }
// 	    return result;
// 	  },
// 	  pixelsPerSecond = (config.speed || 1) * 100,
// 	  snap = config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
// 	  timeOffset = 0,
// 	  container =
// 	    center === true
// 	      ? items[0].parentNode
// 	      : gsap.utils.toArray(center)[0] || items[0].parentNode,
// 	  totalHeight,
// 	  getTotalHeight = () =>
// 	    items[length - 1].offsetTop +
// 	    (yPercents[length - 1] / 100) * heights[length - 1] -
// 	    startY +
// 	    spaceBefore[0] +
// 	    items[length - 1].offsetHeight *
// 	      gsap.getProperty(items[length - 1], "scaleY") +
// 	    (parseFloat(config.paddingBottom) || 0),
// 	  populateHeights = () => {
// 	    let b1 = container.getBoundingClientRect(),
// 	      b2;
// 	    items.forEach((el, i) => {
// 	      heights[i] = parseFloat(gsap.getProperty(el, "height", "px"));
// 	      yPercents[i] = snap(
// 		(parseFloat(gsap.getProperty(el, "y", "px")) / heights[i]) * 100 +
// 		  gsap.getProperty(el, "yPercent")
// 	      );
// 	      b2 = el.getBoundingClientRect();
// 	      spaceBefore[i] = b2.top - (i ? b1.bottom : b1.top);
// 	      b1 = b2;
// 	    });
// 	    gsap.set(items, {
// 	      // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
// 	      yPercent: (i) => yPercents[i]
// 	    });
// 	    totalHeight = getTotalHeight();
// 	  },
// 	  timeWrap,
// 	  populateOffsets = () => {
// 	    timeOffset = center
// 	      ? (tl.duration() * (container.offsetWidth / 2)) / totalHeight
// 	      : 0;
// 	    center &&
// 	      times.forEach((t, i) => {
// 		times[i] = timeWrap(
// 		  tl.labels["label" + i] +
// 		    (tl.duration() * heights[i]) / 2 / totalHeight -
// 		    timeOffset
// 		);
// 	      });
// 	  },
// 	  getClosest = (values, value, wrap) => {
// 	    let i = values.length,
// 	      closest = 1e10,
// 	      index = 0,
// 	      d;
// 	    while (i--) {
// 	      d = Math.abs(values[i] - value);
// 	      if (d > wrap / 2) {
// 		d = wrap - d;
// 	      }
// 	      if (d < closest) {
// 		closest = d;
// 		index = i;
// 	      }
// 	    }
// 	    return index;
// 	  },
// 	  populateTimeline = () => {
// 	    let i, item, curY, distanceToStart, distanceToLoop;
// 	    tl.clear();
// 	    for (i = 0; i < length; i++) {
// 	      item = items[i];
// 	      curY = (yPercents[i] / 100) * heights[i];
// 	      distanceToStart = item.offsetTop + curY - startY + spaceBefore[0];
// 	      distanceToLoop =
// 		distanceToStart + heights[i] * gsap.getProperty(item, "scaleY");
// 	      tl.to(
// 		item,
// 		{
// 		  yPercent: snap(((curY - distanceToLoop) / heights[i]) * 100),
// 		  duration: distanceToLoop / pixelsPerSecond
// 		},
// 		0
// 	      )
// 		.fromTo(
// 		  item,
// 		  {
// 		    yPercent: snap(
// 		      ((curY - distanceToLoop + totalHeight) / heights[i]) * 100
// 		    )
// 		  },
// 		  {
// 		    yPercent: yPercents[i],
// 		    duration:
// 		      (curY - distanceToLoop + totalHeight - curY) / pixelsPerSecond,
// 		    immediateRender: false
// 		  },
// 		  distanceToLoop / pixelsPerSecond
// 		)
// 		.add("label" + i, distanceToStart / pixelsPerSecond);
// 	      times[i] = distanceToStart / pixelsPerSecond;
// 	    }
// 	    timeWrap = gsap.utils.wrap(0, tl.duration());
// 	  },
// 	  refresh = (deep) => {
// 	    let progress = tl.progress();
// 	    tl.progress(0, true);
// 	    populateHeights();
// 	    deep && populateTimeline();
// 	    populateOffsets();
// 	    deep && tl.draggable
// 	      ? tl.time(times[curIndex], true)
// 	      : tl.progress(progress, true);
// 	  },
// 	  proxy;
// 	gsap.set(items, { y: 0 });
// 	populateHeights();
// 	populateTimeline();
// 	populateOffsets();
// 	window.addEventListener("resize", () => refresh(true));
// 	function toIndex(index, vars) {
// 	  vars = clone(vars);
// 	  Math.abs(index - curIndex) > length / 2 &&
// 	    (index += index > curIndex ? -length : length); // always go in the shortest direction
// 	  let newIndex = gsap.utils.wrap(0, length, index),
// 	    time = times[newIndex];
// 	  if (time > tl.time() !== index > curIndex) {
// 	    // if we're wrapping the timeline's playhead, make the proper adjustments
// 	    time += tl.duration() * (index > curIndex ? 1 : -1);
// 	  }
// 	  if (vars.revolutions) {
// 	    time += tl.duration() * Math.round(vars.revolutions);
// 	    delete vars.revolutions;
// 	  }
// 	  if (time < 0 || time > tl.duration()) {
// 	    vars.modifiers = { time: timeWrap };
// 	  }
// 	  curIndex = newIndex;
// 	  vars.overwrite = true;
// 	  gsap.killTweensOf(proxy);
// 	  return tl.tweenTo(time, vars);
// 	}
// 	tl.elements = items;
// 	tl.next = (vars) => toIndex(curIndex + 1, vars);
// 	tl.previous = (vars) => toIndex(curIndex - 1, vars);
// 	tl.current = () => curIndex;
// 	tl.toIndex = (index, vars) => toIndex(index, vars);
// 	tl.closestIndex = (setCurrent) => {
// 	  let index = getClosest(times, tl.time(), tl.duration());
// 	  setCurrent && (curIndex = index);
// 	  return index;
// 	};
// 	tl.times = times;
// 	tl.progress(1, true).progress(0, true); // pre-render for performance
// 	if (config.reversed) {
// 	  tl.vars.onReverseComplete();
// 	  tl.reverse();
// 	}
// 	if (config.draggable && typeof Draggable === "function") {
// 	  proxy = document.createElement("div");
// 	  let wrap = gsap.utils.wrap(0, 1),
// 	    ratio,
// 	    startProgress,
// 	    draggable,
// 	    dragSnap,
// 	    align = () =>
// 	      tl.progress(
// 		wrap(startProgress + (draggable.startY - draggable.y) * ratio)
// 	      ),
// 	    syncIndex = () => tl.closestIndex(true);
// 	  typeof InertiaPlugin === "undefined" &&
// 	    console.warn(
// 	      "InertiaPlugin required for momentum-based scrolling and snapping. https://greensock.com/club"
// 	    );
// 	  draggable = Draggable.create(proxy, {
// 	    trigger: items[0].parentNode,
// 	    type: "y",
// 	    onPressInit() {
// 	      gsap.killTweensOf(tl);
// 	      startProgress = tl.progress();
// 	      refresh();
// 	      ratio = 1 / totalHeight;
// 	      gsap.set(proxy, { y: startProgress / -ratio });
// 	    },
// 	    onDrag: align,
// 	    onThrowUpdate: align,
// 	    inertia: true,
// 	    snap: (value) => {
// 	      let time = -(value * ratio) * tl.duration(),
// 		wrappedTime = timeWrap(time),
// 		snapTime = times[getClosest(times, wrappedTime, tl.duration())],
// 		dif = snapTime - wrappedTime;
// 	      Math.abs(dif) > tl.duration() / 2 &&
// 		(dif += dif < 0 ? tl.duration() : -tl.duration());
// 	      return (time + dif) / tl.duration() / -ratio;
// 	    },
// 	    onRelease: syncIndex,
// 	    onThrowComplete: syncIndex
// 	  })[0];
// 	  tl.draggable = draggable;
// 	}
// 	tl.closestIndex(true);
// 	onChange && onChange(items[curIndex], curIndex);
// 	return tl;
//       }

		/*
		tween.to(".left-panel", {
			duration: 0.5,
			opacity: 1,
			translateX: 0,
		}, '-=0.5')

		tween.to(".main__title", {
			duration: 1,
			opacity: 1,
			translateY: 0
		}, '-=0.25')

		tween.to(".main__title span", {
			duration: 1,
			color: "#CFA604"
		}, '-=0.45')

		tween.to(".main__btns", {
			duration: 1,
			opacity: 1,
			translateY: 0
		}, '-=1.2')

		tween.to(".main__advantage-item", {
			duration: 1,
			opacity: 1,
			translateY: 0,
			stagger: 0.2,
		}, '-=0.7')


		tween.to(".main__coube", {
			duration: 0.7,
			opacity: 1,
			scale: 1,
			stagger: 0.1,
		}, '-=0.7')


		tween.to(".left-panel__social", {
			duration: 1.5,
			opacity: 1,
			translateY: 0,
			ease: "bounce",
		})


		gsap.to(".service-box",{
			scrollTrigger: {
				trigger: ".services",
				toggleActions: "play reverse restart reset",
				scrub: 1,
				end: "bottom bottom",
			},
			duration: 1.5,
			scale: 1,
			opacity: 1,
			stagger: 0.2
		});

		gsap.to(".reviews .container",{
			scrollTrigger: {
				trigger: ".reviews",
				toggleActions: "play reverse restart reset",
				scrub: 1,
				end: "bottom bottom",
			},
			duration: 1,
			y: 0,
			opacity: 1
		});


		gsap.to(".portfolio .container",{
			scrollTrigger: {
				trigger: ".portfolio",
				toggleActions: "play reverse restart reset",
				scrub: 1,
				end: "bottom bottom",
			},
			duration: 1,
			y: 0,
			opacity: 1
		});




		const company = gsap.timeline({
			scrollTrigger: {
				trigger: ".company",
				toggleActions: "play reverse restart reset",
				scrub: 2,
				start: "top center",
				end: "bottom bottom",
			},
			repeat: 0,
			repeatDelay: 1
		});

		company.to(".company__image", {
			duration: 0.5,
			opacity: 1,
			translateX: 0
		})

		company.to(".company__container", {
			duration: 0.5,
			opacity: 1,
			translateY: 0
		}, "-=0.5")


		ScrollTrigger.batch(".calculator__item", {
			onEnter: batch => gsap.to(batch, {
				opacity: 1,
				scale: 1,
				y: 0,
				stagger: 0.1,
			}),
		});

		ScrollTrigger.batch(".article", {
			onEnter: batch => gsap.to(batch, {
				opacity: 1,
				scale: 1,
				y: 0,
				stagger: 0.1,
			}),
			onLeave: batch => gsap.to(batch, {
				opacity: 0,
				scale: 1.5,
				stagger: 0.1
			}),
			onEnterBack: batch => gsap.to(batch, {
				opacity: 1,
				scale: 1,
				stagger: 0.1
			}),
			onLeaveBack: batch => gsap.to(batch, {
				opacity: 0,
				scale: 1.5,
				stagger: 0.1
			}),
		});*/

	}
})


svg4everybody();

window.$ = $;
window.jQuery = $;
window.gsap = gsap;


